import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext({ merchant: null, token: null, login: () => {}, register: () => {}, logout: () => {}, loading: true });

export function AuthProvider({ children }) {
    const [merchant, setMerchant] = useState(() => {
        try { return JSON.parse(localStorage.getItem("wr_merchant") || "null"); } catch { return null; }
    });
    const [token, setToken] = useState(() => localStorage.getItem("wr_token"));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verify = async () => {
            if (token) {
                try {
                    const { data } = await api.get("/auth/me");
                    setMerchant(data);
                    localStorage.setItem("wr_merchant", JSON.stringify(data));
                } catch {
                    setMerchant(null);
                    setToken(null);
                    localStorage.removeItem("wr_token");
                    localStorage.removeItem("wr_merchant");
                }
            }
            setLoading(false);
        };
        verify();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAuth = (data) => {
        setToken(data.token);
        setMerchant(data.merchant);
        localStorage.setItem("wr_token", data.token);
        localStorage.setItem("wr_merchant", JSON.stringify(data.merchant));
    };

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        handleAuth(data);
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        handleAuth(data);
        return data;
    };

    const logout = () => {
        setToken(null);
        setMerchant(null);
        localStorage.removeItem("wr_token");
        localStorage.removeItem("wr_merchant");
    };

    return (
        <AuthCtx.Provider value={{ merchant, token, login, register, logout, loading }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
